import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  ButtonGroup,
} from '@chakra-ui/react';
import { useRef } from 'react';
import { DialogType } from '../../state/dialogs';

interface SimpleDialogProps {
  type: DialogType;
  title: string;
  content: React.ReactNode | string;
  loading: boolean;
  open: boolean;
  mainActionLabel: string;
  cancelLabel: string;
  onMainAction: () => void | Promise<any>;
  onCancel: () => void;
}

const SimpleDialog: React.FC<SimpleDialogProps> = ({
  type,
  title,
  content,
  loading,
  open,
  onCancel,
  onMainAction,
  mainActionLabel,
  cancelLabel,
}) => {
  const cancelRef = useRef(null);

  const CancelAction =
    type === 'confirm' ? (
      <Button colorScheme="gray" variant="ghost" onClick={onCancel} isDisabled={loading}>
        {cancelLabel}
      </Button>
    ) : null;

  return (
    <AlertDialog
      isOpen={open}
      onClose={onCancel}
      leastDestructiveRef={cancelRef}
      closeOnEsc={false}
      closeOnOverlayClick={!loading}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader>{title}</AlertDialogHeader>

          <AlertDialogBody
            sx={{ fontSize: 16, ul: { padding: 'inherit', py: '16px', margin: 'inherit' } }}
          >
            {content}
          </AlertDialogBody>

          <AlertDialogFooter>
            <ButtonGroup>
              {CancelAction}

              <Button variant="primary" onClick={onMainAction} isLoading={loading}>
                {mainActionLabel}
              </Button>
            </ButtonGroup>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default SimpleDialog;
